/* ═══════════════════════════════════════════════════════════════════════════
   ENDRO — Routine Anti-Âge v3 (Liquid) — Logique JS globale
   - Scroll reveal partagé (.endro-reveal → .is-in)
   - (les logiques par section sont ajoutées au fil de la conversion :
      toggle Matin/Soir, accordion FAQ, sticky mobile, etc.)
   ═══════════════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  // ─── Scroll reveal partagé ───────────────────────────────────────────
  function initReveal() {
    var els = document.querySelectorAll('.endro-reveal');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('is-in');
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.2 });
    els.forEach(function (el) { io.observe(el); });
  }

  function onReady(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  // ─── Smooth-scroll partagé ([data-scroll-target]) ────────────────────
  function initScrollTargets(root) {
    (root || document).querySelectorAll('[data-scroll-target]').forEach(function (btn) {
      if (btn.__bound) return;
      btn.__bound = true;
      btn.addEventListener('click', function () {
        var t = btn.getAttribute('data-scroll-target');
        if (!t || t === 'top') { window.scrollTo({ top: 0, behavior: 'smooth' }); return; }
        var el = document.getElementById(t);
        if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  }

  // ─── Hero : galerie + compose + prix + réassurances ──────────────────
  function fmtEuro(n) {
    return n.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €';
  }
  function fill(tpl, map) {
    return String(tpl || '').replace(/\{(\w+)\}/g, function (_, k) {
      return map[k] != null ? map[k] : '';
    });
  }
  function plural(str, n) {
    return n > 1 ? str : str.replace(/produits/g, 'produit');
  }

  function initHero(root) {
    var hero = (root || document).querySelector('[data-endro-hero]');
    if (!hero || hero.__heroBound) return;
    hero.__heroBound = true;

    var discount = (parseFloat(hero.getAttribute('data-discount')) || 0) / 100;

    /* — Galerie — */
    var track = hero.querySelector('[data-gallery-track]');
    var fades = hero.querySelectorAll('[data-gallery-fade]');
    var thumbs = hero.querySelectorAll('[data-gallery-thumb]');
    var dots = hero.querySelectorAll('[data-gallery-dot]');
    var active = 0;
    function setActive(i) {
      active = i;
      fades.forEach(function (f, k) { f.classList.toggle('is-active', k === i); });
      thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === i); });
      dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
    }
    if (track) {
      track.addEventListener('scroll', function () {
        var idx = Math.round(track.scrollLeft / track.clientWidth);
        if (idx !== active) setActive(idx);
      }, { passive: true });
    }
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () { setActive(parseInt(t.getAttribute('data-gallery-thumb'), 10)); });
    });
    dots.forEach(function (d) {
      d.addEventListener('click', function () {
        var i = parseInt(d.getAttribute('data-gallery-dot'), 10);
        if (track) track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' });
        setActive(i);
      });
    });

    /* — Compose + prix + CTA — */
    var rows = Array.prototype.slice.call(hero.querySelectorAll('[data-product]'));
    var total = rows.length;
    var elPrice = hero.querySelector('[data-final-price]');
    var elOld = hero.querySelector('[data-old-price]');
    var elBadge = hero.querySelector('[data-discount-badge]');
    var elNote = hero.querySelector('[data-price-note]');
    var elCta = hero.querySelector('[data-cta]');
    var productUrl = hero.getAttribute('data-product-url');
    var T = {
      ctaFull: hero.getAttribute('data-cta-full'),
      ctaPartial: hero.getAttribute('data-cta-partial'),
      ctaEmpty: hero.getAttribute('data-cta-empty'),
      saveFull: hero.getAttribute('data-save-full'),
      savePartial: hero.getAttribute('data-save-partial'),
      saveEmpty: hero.getAttribute('data-save-empty')
    };
    var dPct = Math.round(discount * 100);

    function recompute() {
      var on = rows.filter(function (r) { return r.classList.contains('is-on'); });
      var count = on.length;
      var subtotal = on.reduce(function (s, r) { return s + (parseFloat(r.getAttribute('data-price')) || 0); }, 0);
      var isFull = count === total && total > 0;
      var finalP = isFull ? subtotal * (1 - discount) : subtotal;
      var savings = isFull ? subtotal - finalP : 0;

      if (elPrice) elPrice.textContent = fmtEuro(finalP);
      if (elOld) { elOld.hidden = !isFull; elOld.textContent = fmtEuro(subtotal); }
      if (elBadge) elBadge.hidden = !isFull;

      if (elNote) {
        elNote.classList.toggle('is-full', isFull);
        if (isFull) elNote.textContent = fill(T.saveFull, { save: fmtEuro(savings) });
        else if (count === 0) elNote.textContent = T.saveEmpty;
        else elNote.textContent = plural(fill(T.savePartial, { n: total - count, d: dPct }), total - count);
      }
      if (elCta) {
        elCta.disabled = count === 0;
        if (isFull) elCta.textContent = fill(T.ctaFull, { price: fmtEuro(finalP) });
        else if (count === 0) elCta.textContent = T.ctaEmpty;
        else elCta.textContent = plural(fill(T.ctaPartial, { n: count, price: fmtEuro(finalP) }), count);
      }
    }

    rows.forEach(function (row) {
      var btn = row.querySelector('[data-toggle]');
      if (!btn) return;
      btn.addEventListener('click', function () {
        var on = row.classList.toggle('is-on');
        row.classList.toggle('is-off', !on);
        btn.setAttribute('aria-pressed', on ? 'true' : 'false');
        var minus = btn.querySelector('.ico-minus');
        var plus = btn.querySelector('.ico-plus');
        if (minus) minus.style.display = on ? '' : 'none';
        if (plus) plus.style.display = on ? 'none' : '';
        recompute();
      });
    });
    if (elCta) {
      elCta.addEventListener('click', function () {
        if (!elCta.disabled && productUrl) window.location.href = productUrl;
      });
    }
    recompute();

    /* — Réassurances : slider auto mobile — */
    var rTrack = hero.querySelector('[data-reassure-track]');
    var rDots = hero.querySelectorAll('[data-reassure-dot]');
    if (rTrack && rDots.length) {
      var rIdx = 0;
      var rN = rDots.length;
      function setR(i) {
        rIdx = i;
        rTrack.style.transform = 'translateX(-' + (i * 100) + '%)';
        rDots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
      }
      rDots.forEach(function (d, k) { d.addEventListener('click', function () { setR(k); }); });
      setInterval(function () { setR((rIdx + 1) % rN); }, 2800);
    }
  }

  // ─── Hero HV : galerie + compose full-row + tuile verte + count ─────
  function initHeroHv(root) {
    var hero = (root || document).querySelector('[data-endro-hero-hv]');
    if (!hero || hero.__heroHvBound) return;
    hero.__heroHvBound = true;

    /* ── Table des packs (miroir de PACKS[] dans HeroProduct.tsx) ─── */
    var PACKS_HV = [
      { key: 'creme-jour|serum-repulpant',                                     name: 'Duo Visage Repulpant',          price: 42.56, compareAt: 44.80, discount: 5,  reviews: 280, url: '/products/duo-visage-routine-anti-age-repulpant' },
      { key: 'creme-nuit|serum-liftant',                                        name: 'Duo Visage Liftant',             price: 42.56, compareAt: 44.80, discount: 5,  reviews: 260, url: '/products/duo-collagene' },
      { key: 'serum-liftant|serum-repulpant',                                   name: 'Duo Sérums Anti-Âge',            price: 47.31, compareAt: 49.80, discount: 5,  reviews: 346, url: '/products/duo-serums-anti-age' },
      { key: 'creme-jour|creme-nuit',                                           name: 'Duo Crèmes Anti-Âge',            price: 37.81, compareAt: 39.80, discount: 5,  reviews: 532, url: '/products/duo-creme-anti-age-jour-et-nuit' },
      { key: 'contour-yeux|creme-jour|serum-repulpant',                         name: 'Routine Anti-Âge Repulpant',     price: 56.72, compareAt: 59.70, discount: 5,  reviews: 931, url: '/products/routine-visage-anti-age' },
      { key: 'contour-yeux|creme-nuit|serum-liftant',                           name: 'Routine Anti-Âge Liftant',       price: 56.72, compareAt: 59.70, discount: 5,  reviews: 810, url: '/products/routine-visage-anti-age-lifting-et-fermete' },
      { key: 'contour-yeux|creme-jour|creme-nuit|serum-liftant|serum-repulpant',name: 'Routine Complète Jour & Nuit',   price: 94.05, compareAt: 104.50, discount: 10, reviews: 390, url: '/products/routine-visage-anti-age-complete-peaux-matures' },
    ];

    /* ── Galeries par pack ─────────────────────────────────────────── */
    var CDN_HV = 'https://cdn.shopify.com/s/files/1/0262/5313/1854/files/';
    var GALLERIES_HV = {
      'creme-jour|serum-repulpant': [
        CDN_HV + 'duo-visage-routine-anti-age-repulpant-endro-cosmetiques-8158873.webp',
        CDN_HV + 'duo-visage-routine-anti-age-repulpant-endro-cosmetiques-5560805.webp',
        CDN_HV + 'duo-serums-anti-age-endro-cosmetiques-5779870.webp',
        CDN_HV + 'duo-serums-anti-age-endro-cosmetiques-4570658.webp',
        CDN_HV + 'duo-cremes-anti-age-endro-cosmetiques-3974719.webp',
        CDN_HV + 'duo-cremes-anti-age-endro-cosmetiques-9072852.webp',
        CDN_HV + 'routine-visage-anti-age-jour-nuit-endro-cosmetiques-7656766.webp',
      ],
      'creme-nuit|serum-liftant': [
        CDN_HV + 'duo-visage-routine-anti-age-liftant-endro-cosmetiques-4355331.webp',
        CDN_HV + 'duo-visage-routine-anti-age-liftant-endro-cosmetiques-8294935.webp',
        CDN_HV + 'duo-cremes-anti-age-endro-cosmetiques-6030759.webp',
        CDN_HV + 'duo-serums-anti-age-endro-cosmetiques-5801558.webp',
        CDN_HV + 'duo-cremes-anti-age-endro-cosmetiques-6716006.webp',
        CDN_HV + 'routine-complete-anti-age-liftant-endro-cosmetiques-8512926.webp',
        CDN_HV + 'routine-complete-anti-age-liftant-endro-cosmetiques-7002466.webp',
      ],
      'serum-liftant|serum-repulpant': [
        CDN_HV + 'duo-serums-anti-age-endro-cosmetiques-9554722.webp',
        CDN_HV + 'duo-serums-anti-age-endro-cosmetiques-5779870.webp',
        CDN_HV + 'duo-serums-anti-age-endro-cosmetiques-5522909.webp',
        CDN_HV + 'duo-serums-anti-age-endro-cosmetiques-4570658.webp',
        CDN_HV + 'duo-serums-anti-age-endro-cosmetiques-1063622.webp',
        CDN_HV + 'duo-serums-anti-age-endro-cosmetiques-5801558.webp',
        CDN_HV + 'duo-serums-anti-age-endro-cosmetiques-6110313.webp',
      ],
      'creme-jour|creme-nuit': [
        CDN_HV + 'duo-cremes-anti-age-endro-cosmetiques-2775391.webp',
        CDN_HV + 'duo-cremes-anti-age-endro-cosmetiques-8204886.webp',
        CDN_HV + 'duo-cremes-anti-age-endro-cosmetiques-3974719.webp',
        CDN_HV + 'duo-cremes-anti-age-endro-cosmetiques-9072852.webp',
        CDN_HV + 'duo-cremes-anti-age-endro-cosmetiques-6716006.webp',
        CDN_HV + 'duo-cremes-anti-age-endro-cosmetiques-6030759.webp',
      ],
      'contour-yeux|creme-jour|serum-repulpant': [
        CDN_HV + 'routine-complete-anti-age-repulpant-endro-cosmetiques-4611921.webp',
        CDN_HV + 'routine-complete-anti-age-repulpant-endro-cosmetiques-5204662.webp',
        CDN_HV + 'duo-serums-anti-age-endro-cosmetiques-5779870.webp',
        CDN_HV + 'duo-serums-anti-age-endro-cosmetiques-5522909.webp',
        CDN_HV + 'duo-cremes-anti-age-endro-cosmetiques-3974719.webp',
        CDN_HV + 'duo-cremes-anti-age-endro-cosmetiques-8204886.webp',
        CDN_HV + 'routine-anti-taches-brunes-endro-cosmetiques-coffret-4209211.webp',
      ],
      'contour-yeux|creme-nuit|serum-liftant': [
        CDN_HV + 'routine-complete-anti-age-liftant-endro-cosmetiques-4727433.webp',
        CDN_HV + 'routine-complete-anti-age-liftant-endro-cosmetiques-5616940.webp',
        CDN_HV + 'routine-complete-anti-age-liftant-endro-cosmetiques-6307914.webp',
        CDN_HV + 'routine-complete-anti-age-liftant-endro-cosmetiques-8512926.webp',
        CDN_HV + 'routine-complete-anti-age-liftant-endro-cosmetiques-7002466.webp',
        CDN_HV + 'duo-serums-anti-age-endro-cosmetiques-5801558.webp',
        CDN_HV + 'duo-cremes-anti-age-endro-cosmetiques-6030759.webp',
      ],
      'contour-yeux|creme-jour|creme-nuit|serum-liftant|serum-repulpant': [
        CDN_HV + 'routine-visage-anti-age-jour-nuit-endro-cosmetiques-2338967.webp',
        CDN_HV + 'routine-visage-anti-age-jour-nuit-endro-cosmetiques-1723968.webp',
        CDN_HV + 'routine-visage-anti-age-jour-nuit-endro-cosmetiques-7656766.webp',
        CDN_HV + 'routine-anti-taches-brunes-endro-cosmetiques-coffret-4209211.webp',
        CDN_HV + 'duo-serums-anti-age-endro-cosmetiques-5522909.webp',
        CDN_HV + 'duo-serums-anti-age-endro-cosmetiques-6110313.webp',
        CDN_HV + 'duo-cremes-anti-age-endro-cosmetiques-6716006.webp',
      ],
    };

    /* ── Galerie — */
    var track = hero.querySelector('[data-gallery-track]');
    var fades = Array.prototype.slice.call(hero.querySelectorAll('[data-gallery-fade]'));
    var thumbs = Array.prototype.slice.call(hero.querySelectorAll('[data-gallery-thumb]'));
    var dots = Array.prototype.slice.call(hero.querySelectorAll('[data-gallery-dot]'));
    var slides = track ? Array.prototype.slice.call(track.querySelectorAll('.endro-aa-slide img')) : [];
    var thumbImgs = thumbs.map(function (t) { return t.querySelector('img'); });
    var active = 0;

    function setActive(i) {
      active = i;
      fades.forEach(function (f, k) { f.classList.toggle('is-active', k === i); });
      thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === i); });
      dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
    }

    function updateGallery(urls) {
      if (!urls || !urls.length) return;
      setActive(0);
      if (track) track.scrollTo({ left: 0, behavior: 'auto' });
      fades.forEach(function (f, k) { if (urls[k]) f.setAttribute('src', urls[k] + '?width=1920'); });
      slides.forEach(function (img, k) { if (urls[k]) img.setAttribute('src', urls[k] + '?width=1920'); });
      thumbImgs.forEach(function (img, k) { if (img && urls[k]) img.setAttribute('src', urls[k] + '?width=128'); });
    }

    if (track) {
      track.addEventListener('scroll', function () {
        var idx = Math.round(track.scrollLeft / track.clientWidth);
        if (idx !== active) setActive(idx);
      }, { passive: true });
    }
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () { setActive(parseInt(t.getAttribute('data-gallery-thumb'), 10)); });
    });
    dots.forEach(function (d) {
      d.addEventListener('click', function () {
        var i = parseInt(d.getAttribute('data-gallery-dot'), 10);
        if (track) track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' });
        setActive(i);
      });
    });

    /* ── Compose + count + prix + CTA — */
    var rows = Array.prototype.slice.call(hero.querySelectorAll('[data-product]'));
    var total = rows.length;
    var elPrice = hero.querySelector('[data-final-price]');
    var elOld = hero.querySelector('[data-old-price]');
    var elBadge = hero.querySelector('[data-discount-badge]');
    var elNote = hero.querySelector('[data-price-note]');
    var elCta = hero.querySelector('[data-cta]');
    var elCountSel = hero.querySelector('[data-selected-count]');
    var elRatingCount = hero.querySelector('[data-rating-count]');
    var elStickerVal = hero.querySelector('[data-sticker-val]');
    var selAllBtn = hero.querySelector('[data-select-all]');
    var selAllDef = selAllBtn ? selAllBtn.querySelector('.endro-aa-hv-sa-default') : null;
    var selAllDone = selAllBtn ? selAllBtn.querySelector('.endro-aa-hv-sa-done') : null;
    var T = {
      ctaPartial: hero.getAttribute('data-cta-partial'),
      ctaEmpty: hero.getAttribute('data-cta-empty'),
      savePartial: hero.getAttribute('data-save-partial'),
      saveEmpty: hero.getAttribute('data-save-empty'),
    };

    var prevPackKey = null;

    function recomputeHv() {
      var on = rows.filter(function (r) { return r.classList.contains('is-on'); });
      var count = on.length;
      var isFull = count === total && total > 0;

      /* — Détection pack — */
      var slugKey = on.map(function (r) { return r.getAttribute('data-slug') || ''; }).filter(Boolean).sort().join('|');
      var pack = null;
      for (var i = 0; i < PACKS_HV.length; i++) {
        if (PACKS_HV[i].key === slugKey) { pack = PACKS_HV[i]; break; }
      }

      if (elCountSel) elCountSel.textContent = count;

      if (selAllDef && selAllDone) {
        selAllDef.hidden = isFull;
        selAllDone.hidden = !isFull;
      }

      var finalP, oldP, discount, savings;
      if (pack) {
        finalP  = pack.price;
        oldP    = pack.compareAt;
        discount = pack.discount;
        savings  = oldP - finalP;
        if (elRatingCount) elRatingCount.textContent = pack.reviews + ' avis';
        if (elStickerVal)  elStickerVal.textContent  = '−' + discount + ' %';
        if (pack.key !== prevPackKey && GALLERIES_HV[pack.key]) {
          updateGallery(GALLERIES_HV[pack.key]);
        }
        prevPackKey = pack.key;
        hero.setAttribute('data-product-url', pack.url);
      } else {
        finalP   = on.reduce(function (s, r) { return s + (parseFloat(r.getAttribute('data-price')) || 0); }, 0);
        oldP     = 0;
        discount = 0;
        savings  = 0;
        prevPackKey = null;
      }

      if (elPrice) elPrice.textContent = count > 0 ? fmtEuro(finalP) : '';
      if (elOld)   { elOld.hidden = !(pack && oldP); if (pack && oldP) elOld.textContent = fmtEuro(oldP); }
      if (elBadge) {
        elBadge.hidden = !(pack && discount);
        if (pack && discount) elBadge.textContent = '−' + discount + ' %';
      }

      if (elNote) {
        if (pack && discount > 0) {
          elNote.classList.add('is-full');
          elNote.textContent = 'Vous économisez ' + fmtEuro(savings) + ' avec ' + pack.name;
        } else if (count === 0) {
          elNote.classList.remove('is-full');
          elNote.textContent = T.saveEmpty || 'Sélectionnez au moins un produit';
        } else {
          elNote.classList.remove('is-full');
          elNote.textContent = T.savePartial || 'Combinez nos soins pour découvrir nos packs';
        }
      }

      if (elCta) {
        elCta.disabled = count === 0;
        elCta.textContent = count === 0
          ? (T.ctaEmpty || 'Choisissez vos produits')
          : fill(T.ctaPartial || 'Ajouter au panier · {price}', { price: fmtEuro(finalP) });
      }
    }

    /* Full-row click (the row IS the button) */
    rows.forEach(function (row) {
      row.addEventListener('click', function () {
        var on = row.classList.toggle('is-on');
        row.classList.toggle('is-off', !on);
        row.setAttribute('aria-pressed', on ? 'true' : 'false');
        recomputeHv();
      });
    });

    /* Select-all tile */
    if (selAllBtn) {
      selAllBtn.addEventListener('click', function () {
        var isFull = rows.every(function (r) { return r.classList.contains('is-on'); });
        if (!isFull) {
          rows.forEach(function (r) {
            r.classList.add('is-on');
            r.classList.remove('is-off');
            r.setAttribute('aria-pressed', 'true');
          });
          recomputeHv();
        }
      });
    }

    if (elCta) {
      elCta.addEventListener('click', function () {
        var url = hero.getAttribute('data-product-url');
        if (!elCta.disabled && url) window.location.href = url;
      });
    }
    recomputeHv();

    /* — Réassurances : slider auto mobile — */
    var rTrack = hero.querySelector('[data-reassure-track]');
    var rDots = hero.querySelectorAll('[data-reassure-dot]');
    if (rTrack && rDots.length) {
      var rIdx = 0;
      var rN = rDots.length;
      function setR(i) {
        rIdx = i;
        rTrack.style.transform = 'translateX(-' + (i * 100) + '%)';
        rDots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
      }
      rDots.forEach(function (d, k) { d.addEventListener('click', function () { setR(k); }); });
      setInterval(function () { setR((rIdx + 1) % rN); }, 2800);
    }
  }

  // ─── Intro Schema : toggle Matin/Soir + carrousel ────────────────────
  function replayCswap(scope) {
    scope.querySelectorAll('.endro-aa-cswap').forEach(function (el) {
      el.style.animation = 'none';
      // force reflow
      void el.offsetWidth;
      el.style.animation = '';
    });
  }

  function initRoutineCarousel(routine) {
    if (routine.__carBound) {
      // ré-évalue juste le dot actif (réaffiché)
    }
    var scroll = routine.querySelector('[data-intro-scroll]');
    var dots = routine.querySelectorAll('[data-intro-dot]');
    var steps = routine.querySelectorAll('.endro-aa-intro-scroll .endro-aa-step');
    if (!scroll || !dots.length) return;

    function setDot(i) {
      dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
    }
    if (!routine.__carBound) {
      routine.__carBound = true;
      dots.forEach(function (d, k) {
        d.addEventListener('click', function () {
          var el = steps[k];
          if (el) el.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
        });
      });
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (en) {
            if (en.isIntersecting && en.intersectionRatio > 0.55) {
              var idx = parseInt(en.target.getAttribute('data-step-index'), 10);
              if (!isNaN(idx)) setDot(idx);
            }
          });
        }, { threshold: [0.55, 0.75], root: scroll });
        steps.forEach(function (s) { io.observe(s); });
      }
    }
    scroll.scrollLeft = 0;
    setDot(0);
  }

  function initIntro(root) {
    (root || document).querySelectorAll('[data-intro]').forEach(function (sec) {
      if (sec.__introBound) return;
      sec.__introBound = true;
      var segs = sec.querySelectorAll('[data-moment]');
      var routines = sec.querySelectorAll('[data-routine]');
      var hintEl = sec.querySelector('[data-intro-hint]');

      function setMoment(m) {
        sec.classList.toggle('is-soir', m === 'soir');
        if (hintEl) {
          hintEl.textContent = m === 'soir'
            ? (sec.getAttribute('data-hint-soir') || '')
            : (sec.getAttribute('data-hint-matin') || '');
        }
        segs.forEach(function (b) {
          var on = b.getAttribute('data-moment') === m;
          b.classList.toggle('is-active', on);
          b.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        routines.forEach(function (r) {
          var on = r.getAttribute('data-routine') === m;
          r.hidden = !on;
          if (on) { replayCswap(r); initRoutineCarousel(r); }
        });
      }

      segs.forEach(function (b) {
        b.addEventListener('click', function () { setMoment(b.getAttribute('data-moment')); });
      });

      // init routine visible au chargement
      routines.forEach(function (r) { if (!r.hidden) initRoutineCarousel(r); });
    });
  }

  // ─── Testé & approuvé : slideshow mobile auto ────────────────────────
  function initTea(root) {
    (root || document).querySelectorAll('[data-tea]').forEach(function (box) {
      if (box.__teaBound) return;
      box.__teaBound = true;
      var track = box.querySelector('[data-tea-track]');
      if (!track) return;
      var slides = track.children.length;
      if (slides < 2) return;
      var i = 0, paused = false;
      function go() {
        track.style.transform = 'translateX(-' + (i * 100) + '%)';
      }
      box.addEventListener('touchstart', function () { paused = true; }, { passive: true });
      box.addEventListener('touchend', function () { paused = false; }, { passive: true });
      setInterval(function () {
        if (paused) return;
        i = (i + 1) % slides;
        go();
      }, 2500);
    });
  }

  // ─── Catalogue : tabs filtre + fade-up staggered ─────────────────────
  function initCatalogue(root) {
    (root || document).querySelectorAll('[data-catalogue]').forEach(function (sec) {
      if (sec.__catBound) return;
      sec.__catBound = true;
      var tabs = sec.querySelectorAll('[data-cat-tab]');
      var grid = sec.querySelector('[data-cat-grid]');
      if (!grid) return;
      var cards = Array.prototype.slice.call(grid.querySelectorAll('.endro-aa-cat-card'));

      function apply(f) {
        tabs.forEach(function (t) {
          var on = t.getAttribute('data-cat-tab') === f;
          t.classList.toggle('is-active', on);
          t.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        var vis = 0;
        cards.forEach(function (c) {
          var show = f === 'all' || c.getAttribute('data-ptype') === f;
          c.hidden = !show;
          if (show) {
            c.style.animation = 'none';
            void c.offsetWidth;
            c.style.animationDelay = (vis * 45) + 'ms';
            c.style.animation = '';
            vis += 1;
          }
        });
      }

      tabs.forEach(function (t) {
        t.addEventListener('click', function () {
          var f = t.getAttribute('data-cat-tab');
          if (t.classList.contains('is-active')) return;
          apply(f);
        });
      });
    });
  }

  // ─── FAQ : accordion single-open ─────────────────────────────────────
  function initFaq(root) {
    (root || document).querySelectorAll('[data-faq]').forEach(function (sec) {
      if (sec.__faqBound) return;
      sec.__faqBound = true;
      var itemsEl = Array.prototype.slice.call(sec.querySelectorAll('[data-faq-item]'));
      itemsEl.forEach(function (item) {
        var btn = item.querySelector('[data-faq-toggle]');
        if (!btn) return;
        btn.addEventListener('click', function () {
          var willOpen = !item.classList.contains('is-open');
          itemsEl.forEach(function (o) {
            o.classList.remove('is-open');
            var b = o.querySelector('[data-faq-toggle]');
            if (b) b.setAttribute('aria-expanded', 'false');
          });
          if (willOpen) {
            item.classList.add('is-open');
            btn.setAttribute('aria-expanded', 'true');
          }
        });
      });
    });
  }

  // ─── Final CTA : parallaxe background ────────────────────────────────
  function initFinalCta(root) {
    (root || document).querySelectorAll('[data-final-cta]').forEach(function (sec) {
      if (sec.__fctaBound) return;
      sec.__fctaBound = true;
      var img = sec.querySelector('[data-fcta-bg]');
      if (!img) return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      var raf = null;
      function update() {
        var rect = sec.getBoundingClientRect();
        var vh = window.innerHeight;
        if (rect.bottom < -100 || rect.top > vh + 100) return;
        var center = rect.top + rect.height / 2;
        var offset = (center - vh / 2) / vh;
        img.style.transform = 'translateY(' + (offset * -130) + 'px)';
      }
      function onScroll() {
        if (raf) return;
        raf = requestAnimationFrame(function () { update(); raf = null; });
      }
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll, { passive: true });
      update();
    });
  }

  // ─── Réassurance bar : auto-scroll mobile (≤699px) ───────────────────
  function initRb(root) {
    (root || document).querySelectorAll('[data-rb]').forEach(function (sec) {
      if (sec.__rbBound) return;
      sec.__rbBound = true;
      var list = sec.querySelector('[data-rb-list]');
      if (!list) return;
      var mql = window.matchMedia('(max-width: 699px)');
      var id = null, paused = false;
      function advance() {
        var w = list.clientWidth;
        var max = list.scrollWidth - w;
        var next = list.scrollLeft + w;
        list.scrollTo({ left: next > max - 4 ? 0 : next, behavior: 'smooth' });
      }
      function start() { if (id == null) id = setInterval(function () { if (!paused) advance(); }, 3000); }
      function stop() { if (id != null) { clearInterval(id); id = null; } }
      list.addEventListener('touchstart', function () { paused = true; }, { passive: true });
      list.addEventListener('touchend', function () { paused = false; }, { passive: true });
      function sync() { if (mql.matches) start(); else stop(); }
      if (mql.addEventListener) mql.addEventListener('change', sync);
      sync();
    });
  }

  // ─── Naturellement : reveal scroll-driven clip-path ──────────────────
  function initNatu(root) {
    (root || document).querySelectorAll('[data-natu]').forEach(function (sec) {
      if (sec.__natuBound) return;
      sec.__natuBound = true;
      var sticky = sec.querySelector('[data-natu-sticky]');
      if (!sticky) return;
      var clipTargets = sec.querySelectorAll('.endro-aa-natu-clipper, .endro-aa-natu-inside');
      var imgs = sec.querySelectorAll('.endro-aa-natu-clipper img');
      var contents = sec.querySelectorAll('.endro-aa-natu-content');
      var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      function easeIn(t) { return t * t; }
      function update() {
        if (reduced) {
          clipTargets.forEach(function (el) { el.style.clipPath = 'inset(0)'; });
          imgs.forEach(function (i) { i.style.transform = 'none'; });
          contents.forEach(function (c) { c.style.opacity = '1'; });
          return;
        }
        var rect = sec.getBoundingClientRect();
        var stickyH = sticky.getBoundingClientRect().height;
        var range = rect.height - stickyH;
        if (range <= 0) return;
        var p = Math.max(0, Math.min(1, -rect.top / range));
        var pE = easeIn(p);
        var t = 37 * (1 - pE), r = 37 * (1 - pE), b = 41 * (1 - pE), l = 37 * (1 - pE);
        var clip = 'inset(' + t + '% ' + r + '% ' + b + '% ' + l + '%)';
        clipTargets.forEach(function (e2) { e2.style.clipPath = clip; });
        var tx = -10 * (1 - pE), ty = -1.5 * (1 - pE), sc = 1 + 0.4 * (1 - pE);
        imgs.forEach(function (i) { i.style.transform = 'translate(' + tx + '%, ' + ty + '%) scale(' + sc + ')'; });
        var opacity = p < 0.25 ? p / 0.25 : 1;
        contents.forEach(function (c) { c.style.opacity = String(opacity); });
      }
      var raf = null;
      function onScroll() {
        if (raf) return;
        raf = requestAnimationFrame(function () { update(); raf = null; });
      }
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll, { passive: true });
      update();
    });
  }

  // ─── Tous les boutons data-variant-id → ajout panier + drawer ─────────
  function initRoutinesCta() {
    document.querySelectorAll('button[data-variant-id]:not([data-pv2-card])').forEach(function (btn) {
      if (btn.__routinesCtaBound) return;
      btn.__routinesCtaBound = true;
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        if (btn.disabled) return;
        var vid = btn.getAttribute('data-variant-id');
        if (!vid) { window.location.href = btn.getAttribute('data-url') || '/cart'; return; }
        var savedText = btn.textContent;
        btn.disabled = true;
        btn.textContent = 'Ajout en cours…';
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: parseInt(vid, 10), quantity: 1 }] }),
        })
          .then(function (res) { if (!res.ok) throw new Error('HTTP ' + res.status); return res.json(); })
          .then(function () {
            btn.textContent = savedText;
            btn.disabled = false;
            document.dispatchEvent(new CustomEvent('cart:refresh'));
            var drawer = document.getElementById('cart-drawer');
            if (drawer && typeof drawer.show === 'function') { drawer.show(); }
            else if (drawer) { drawer.setAttribute('open', ''); }
            else { window.location.href = '/cart'; }
          })
          .catch(function () {
            btn.textContent = savedText;
            btn.disabled = false;
            window.location.href = btn.getAttribute('data-url') || '/cart';
          });
      });
    });
  }

  onReady(function () {
    initReveal();
    initScrollTargets();
    initHero();
    initHeroHv();
    initIntro();
    initTea();
    initCatalogue();
    initFaq();
    initFinalCta();
    initRb();
    initNatu();
    initEndroReponse();
    initEec();
    initHeroProductV2();
    initRoutinesCta();
  });

  // Theme Editor : ré-init quand une section est rechargée
  document.addEventListener('shopify:section:load', function (e) {
    initReveal();
    initScrollTargets(e.target);
    initHero(e.target);
    initHeroHv(e.target);
    initHeroProductV2(e.target);
    initIntro(e.target);
    initTea(e.target);
    initCatalogue(e.target);
    initFaq(e.target);
    initFinalCta(e.target);
    initRb(e.target);
    initNatu(e.target);
    initEndroReponse(e.target);
    initEec(e.target);
    initRoutinesCta();
  });

  // ─── EndroEnChiffres : count-up on scroll ─────────────────────────────
  function initEec(root) {
    var section = (root || document).querySelector('[data-endro-eec]');
    if (!section || section.__eecBound) return;
    section.__eecBound = true;
    var cells = section.querySelectorAll('[data-eec-val]');
    if (!cells.length) return;
    var ran = false;
    function runCountUps() {
      if (ran) return;
      ran = true;
      cells.forEach(function (cell) {
        var isStatic = cell.getAttribute('data-eec-static') === 'true';
        var to  = parseFloat(cell.getAttribute('data-eec-val')) || 0;
        var sfx = cell.getAttribute('data-eec-suffix') || '';
        var numEl = cell.querySelector('[data-eec-num]');
        if (!numEl) return;
        if (isStatic) { numEl.textContent = to.toLocaleString('fr-FR') + sfx; return; }
        var duration = 1400;
        var start = null;
        var raf = 0;
        function easeOut(p) { return p === 1 ? 1 : 1 - Math.pow(2, -10 * p); }
        function tick(ts) {
          if (!start) start = ts;
          var p = Math.min((ts - start) / duration, 1);
          var val = Math.round(easeOut(p) * to);
          numEl.textContent = val.toLocaleString('fr-FR') + sfx;
          if (p < 1) raf = requestAnimationFrame(tick);
        }
        raf = requestAnimationFrame(tick);
      });
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { runCountUps(); io.disconnect(); }
      });
    }, { threshold: 0.2 });
    io.observe(section);
  }

  // ─── EndroReponse : scroll-driven dual panel ─────────────────────────
  function initEndroReponse(root) {
    var outer = (root || document).querySelector('[data-endro-reponse]');
    if (!outer || outer.__erBound) return;
    outer.__erBound = true;

    var sticky    = outer.querySelector('[data-er-sticky]');
    var inner     = outer.querySelector('[data-er-inner]');
    var eyebrow   = outer.querySelector('[data-er-eyebrow]');
    var titleEl   = outer.querySelector('[data-er-title]');
    var progress  = outer.querySelector('[data-er-progress]');
    var imgCol    = outer.querySelector('[data-er-img-col]');
    var imgColImg = imgCol ? imgCol.querySelector('img') : null;
    var imgMobile = outer.querySelector('[data-er-img-mobile]');
    var imgMobImg = imgMobile ? imgMobile.querySelector('img') : null;
    var dots      = outer.querySelectorAll('[data-er-dot]');

    // Parse panel config
    var cfgEl = outer.querySelector('[data-er-config]');
    var panels = [];
    try { panels = JSON.parse(cfgEl.textContent).panels; } catch (e) {}

    var activePanel = 0;
    var raf = 0;

    function applyColors(p) {
      var numColor = p.numberColor || p.accent || '#C8483A';
      var lblColor = p.textColor || '#1A1A1A';
      outer.querySelectorAll('[data-er-num-color]').forEach(function (el) {
        el.style.color = numColor;
      });
      outer.querySelectorAll('[data-er-lbl-color]').forEach(function (el) {
        el.style.color = lblColor;
      });
      if (progress) progress.style.background = p.accent || numColor;
    }

    function setPanel(idx) {
      var p = panels[idx] || {};

      // Fade out
      if (inner) inner.classList.add('is-out');
      if (imgColImg) imgColImg.classList.add('is-out');
      if (imgMobImg) imgMobImg.classList.add('is-out');

      setTimeout(function () {
        // Update text
        if (eyebrow) eyebrow.textContent = p.eyebrow || '';
        if (titleEl) titleEl.textContent = p.title || '';
        titleEl && (titleEl.style.color = p.textColor || (idx === 1 ? '#142E1F' : '#1A1A1A'));

        // Show/hide items per panel
        outer.querySelectorAll('[data-er-item]').forEach(function (li) {
          var key = li.getAttribute('data-er-item');
          li.hidden = key.indexOf(idx + '-') !== 0;
        });

        // Update images
        if (imgColImg) {
          imgColImg.src = imgColImg.getAttribute('data-er-img-src-' + idx) || '';
          imgColImg.classList.remove('is-out');
        }
        if (imgMobImg) {
          imgMobImg.src = imgColImg ? (imgColImg.getAttribute('data-er-img-src-' + idx) || '') : '';
          imgMobImg.classList.remove('is-out');
        }

        // Colors (num ≠ lbl)
        applyColors(p);

        // Progress bar
        if (progress) progress.style.width = idx === 0 ? '50%' : '100%';

        // Dots
        dots.forEach(function (d, k) {
          d.style.width = k === idx ? '24px' : '8px';
          d.style.background = k === idx ? (p.accent || '#142E1F') : 'rgba(0,0,0,.15)';
        });

        // Fade in
        if (inner) inner.classList.remove('is-out');

        activePanel = idx;
      }, 180);
    }

    // Init state
    if (panels[0]) {
      applyColors(panels[0]);
      if (progress) progress.style.width = '50%';
      dots.forEach(function (d, k) {
        d.style.width = k === 0 ? '24px' : '8px';
        d.style.background = k === 0 ? (panels[0].accent || '#C8483A') : 'rgba(0,0,0,.15)';
      });
    }

    var prevPanel = 0;
    function onScroll() {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () {
        var rect = outer.getBoundingClientRect();
        var scrollable = outer.offsetHeight - window.innerHeight;
        if (scrollable <= 0) return;
        var prog = Math.max(0, Math.min(1, -rect.top / scrollable));
        var next = prog < 0.5 ? 0 : 1;
        if (next !== prevPanel) {
          prevPanel = next;
          setPanel(next);
        }
      });
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    // Cleanup on Theme Editor section:unload
    outer.addEventListener('shopify:section:unload', function () {
      window.removeEventListener('scroll', onScroll);
    }, { once: true });
  }

  // ─── Hero Product V2 : grille cartes + packs dynamiques ────────────────
  function initHeroProductV2(root) {
    var hero = (root || document).querySelector('[data-endro-hero-pv2]');
    if (!hero || hero.__hpv2Bound) return;
    hero.__hpv2Bound = true;

    var STORE = 'https://www.endro-cosmetiques.com';
    var PACKS = [
      { key: 'creme-jour|serum-repulpant', name: 'Duo Visage Repulpant', price: 42.56, compareAt: 44.80, discount: 5,
        url: STORE + '/products/duo-visage-routine-anti-age-repulpant', variantId: '52093103931739' },
      { key: 'creme-nuit|serum-liftant', name: 'Duo Visage Liftant', price: 42.56, compareAt: 44.80, discount: 5,
        url: STORE + '/products/duo-collagene', variantId: '52093177889115' },
      { key: 'serum-liftant|serum-repulpant', name: 'Duo Sérums Anti-Âge', price: 47.31, compareAt: 49.80, discount: 5,
        url: STORE + '/products/duo-serums-anti-age', variantId: '52097106149723' },
      { key: 'creme-jour|creme-nuit', name: 'Duo Crèmes Anti-Âge', price: 37.81, compareAt: 39.80, discount: 5,
        url: STORE + '/products/duo-creme-anti-age-jour-et-nuit', variantId: '52097045102939' },
      { key: 'contour-yeux|creme-jour|serum-repulpant', name: 'Routine Anti-Âge Repulpant', price: 56.72, compareAt: 59.70, discount: 5,
        url: STORE + '/products/routine-visage-anti-age', variantId: '52096623083867' },
      { key: 'contour-yeux|creme-nuit|serum-liftant', name: 'Routine Anti-Âge Liftant', price: 56.72, compareAt: 59.70, discount: 5,
        url: STORE + '/products/routine-visage-anti-age-lifting-et-fermete', variantId: '52096862323035' },
      { key: 'contour-yeux|creme-jour|creme-nuit|serum-liftant|serum-repulpant', name: 'Routine Complète Jour & Nuit', price: 94.05, compareAt: 104.50, discount: 10,
        url: STORE + '/products/routine-visage-anti-age-complete-peaux-matures', variantId: '52097000112475' },
    ];
    var FULL_KEY = 'contour-yeux|creme-jour|creme-nuit|serum-liftant|serum-repulpant';
    var FULL_PACK = PACKS[PACKS.length - 1];

    /* ── Image principale (1re position de la galerie) par pack détecté ──
       Le combo par défaut ('contour-yeux|creme-jour|serum-repulpant') est
       volontairement absent : on garde l'image configurée par le marchand
       (position 0) à l'atterrissage tant que la sélection par défaut est active. */
    var CDN_PV2 = 'https://www.endro-cosmetiques.com/cdn/shop/files/';
    var PACK_IMAGE_PV2 = {
      'contour-yeux|creme-jour|creme-nuit|serum-liftant|serum-repulpant': { src: CDN_PV2 + 'routine-visage-anti-age-jour-nuit-endro-cosmetiques-2338967.webp', alt: 'Routine Complète Anti-Âge Endro' },
      'contour-yeux|creme-nuit|serum-liftant':                            { src: CDN_PV2 + 'routine-complete-anti-age-liftant-endro-cosmetiques-4727433.webp', alt: 'Routine Anti-Âge Liftant Endro' },
      'creme-jour|serum-repulpant':                                       { src: CDN_PV2 + 'duo-visage-routine-anti-age-repulpant-endro-cosmetiques-8158873.webp', alt: 'Duo Visage Repulpant Endro' },
      'creme-nuit|serum-liftant':                                         { src: CDN_PV2 + 'duo-visage-routine-anti-age-liftant-endro-cosmetiques-4355331.webp', alt: 'Duo Visage Liftant Endro' },
      'serum-liftant|serum-repulpant':                                    { src: CDN_PV2 + 'duo-serums-anti-age-endro-cosmetiques-9554722.webp', alt: 'Duo Sérums Anti-Âge Endro' },
      'creme-jour|creme-nuit':                                            { src: CDN_PV2 + 'duo-cremes-anti-age-endro-cosmetiques-2775391.webp', alt: 'Duo Crèmes Anti-Âge Endro' },
      /* Un seul produit sélectionné → image du produit seul */
      'serum-repulpant': { src: CDN_PV2 + 'serum-repulpant-endro-cosmetiques-9290899.webp', alt: 'Sérum Repulpant Endro' },
      'creme-jour':       { src: CDN_PV2 + 'creme-de-jour-anti-age-endro-cosmetiques-3101518.webp', alt: 'Crème de Jour Anti-Âge Endro' },
      'contour-yeux':     { src: CDN_PV2 + 'soin-contour-yeux-levres-endro-cosmetiques-contour-des-yeux-5430908.webp', alt: 'Soin Contour Yeux & Lèvres Endro' },
      'serum-liftant':    { src: CDN_PV2 + 'serum-liftant-collagene-endro-cosmetiques-3355944.webp', alt: 'Sérum Liftant Collagène Endro' },
      'creme-nuit':       { src: CDN_PV2 + 'creme-de-nuit-anti-age-collagene-endro-cosmetiques-7708954.webp', alt: 'Crème de Nuit Anti-Âge Endro' },
    };

    function fmtEuro(n) {
      return n.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €';
    }

    /* ── Galerie ── */
    var track  = hero.querySelector('[data-pv2-gallery-track]');
    var fades  = Array.prototype.slice.call(hero.querySelectorAll('[data-pv2-gallery-fade]'));
    var thumbs = Array.prototype.slice.call(hero.querySelectorAll('[data-pv2-gallery-thumb]'));
    var dots   = Array.prototype.slice.call(hero.querySelectorAll('[data-pv2-gallery-dot]'));
    var activeImg = 0;

    function setGallery(i) {
      activeImg = i;
      fades.forEach(function (f, k) { f.classList.toggle('is-active', k === i); });
      thumbs.forEach(function (t, k) {
        t.classList.toggle('is-active', k === i);
        t.setAttribute('aria-current', k === i ? 'true' : 'false');
      });
      dots.forEach(function (d, k) {
        d.classList.toggle('is-active', k === i);
        d.setAttribute('aria-current', k === i ? 'true' : 'false');
      });
    }

    if (track) {
      track.addEventListener('scroll', function () {
        var idx = Math.round(track.scrollLeft / track.clientWidth);
        if (idx !== activeImg && idx >= 0 && idx < fades.length) setGallery(idx);
      }, { passive: true });
    }

    /* Image principale réactive à la sélection (position 0 uniquement, le reste
       de la galerie reste parcourable). Pas d'entrée dans PACK_IMAGE_PV2 pour le
       combo par défaut → on restaure l'image marchand d'origine (capturée au init)
       à chaque fois que la sélection revient au combo par défaut. */
    var origSlideImg = track ? track.querySelector('.endro-aa-hp-slide img') : null;
    var origImage = {
      fadeSrc:  fades[0]  ? fades[0].getAttribute('src') : null,
      fadeAlt:  fades[0]  ? fades[0].getAttribute('alt') : null,
      slideSrc: origSlideImg ? origSlideImg.getAttribute('src') : null,
      slideAlt: origSlideImg ? origSlideImg.getAttribute('alt') : null,
      thumbSrc: (thumbs[0] && thumbs[0].querySelector('img')) ? thumbs[0].querySelector('img').getAttribute('src') : null,
    };
    var prevImageKey = null;
    function updateHeroImage(slugKey) {
      if (slugKey === prevImageKey) return;
      prevImageKey = slugKey;
      var img = PACK_IMAGE_PV2[slugKey];
      var fadeSrc, fadeAlt, slideSrc, slideAlt, thumbSrc;
      if (img) {
        fadeSrc = slideSrc = img.src + '?width=1200';
        fadeAlt = slideAlt = img.alt;
        thumbSrc = img.src + '?width=128';
      } else {
        fadeSrc = origImage.fadeSrc; fadeAlt = origImage.fadeAlt;
        slideSrc = origImage.slideSrc; slideAlt = origImage.slideAlt;
        thumbSrc = origImage.thumbSrc;
      }
      if (fades[0] && fadeSrc) { fades[0].setAttribute('src', fadeSrc); fades[0].setAttribute('alt', fadeAlt); }
      if (origSlideImg && slideSrc) { origSlideImg.setAttribute('src', slideSrc); origSlideImg.setAttribute('alt', slideAlt); }
      if (thumbs[0] && thumbSrc) {
        var thumbImg = thumbs[0].querySelector('img');
        if (thumbImg) thumbImg.setAttribute('src', thumbSrc);
      }
    }
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        setGallery(parseInt(t.getAttribute('data-pv2-gallery-thumb'), 10));
      });
    });
    dots.forEach(function (d) {
      d.addEventListener('click', function () {
        var i = parseInt(d.getAttribute('data-pv2-gallery-dot'), 10);
        if (track) track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' });
        setGallery(i);
      });
    });

    /* ── Cartes produit ── */
    var cards = Array.prototype.slice.call(hero.querySelectorAll('[data-pv2-card]'));

    /* ── Éléments prix / CTA ── */
    var elPrice    = hero.querySelector('[data-pv2-price]');
    var elOld      = hero.querySelector('[data-pv2-old-price]');
    var elBadge    = hero.querySelector('[data-pv2-badge]');
    var elNote     = hero.querySelector('[data-pv2-note]');
    var elCta      = hero.querySelector('[data-pv2-cta]');
    var elCount    = hero.querySelector('[data-pv2-count]');
    var elRestore  = hero.querySelector('[data-pv2-restore]');
    var elRestoreP = hero.querySelector('[data-pv2-restore-price]');

    var T = {
      ctaFull:    hero.getAttribute('data-cta-full')    || 'Ajouter la routine · {price}',
      ctaPartial: hero.getAttribute('data-cta-partial') || 'Ajouter {count} produit{s} · {price}',
      ctaEmpty:   hero.getAttribute('data-cta-empty')   || 'Choisissez vos produits',
      noteFull:   hero.getAttribute('data-note-full')   || 'Vous économisez {savings} avec {pack}',
      notePartial:hero.getAttribute('data-note-partial')|| 'Combinez nos soins pour découvrir nos packs',
      noteEmpty:  hero.getAttribute('data-note-empty')  || 'Sélectionnez au moins un produit',
    };

    function fill(tpl, data) {
      return tpl
        .replace('{price}',   data.price || '')
        .replace('{savings}', data.savings || '')
        .replace('{pack}',    data.pack || '')
        .replace('{count}',   data.count != null ? String(data.count) : '')
        .replace('{s}',       data.count > 1 ? 's' : '');
    }

    var currentUrl = FULL_PACK.url;
    var currentSelection = { on: [], pack: null };

    function getSelection() {
      var on = cards.filter(function (c) { return c.classList.contains('is-on'); });
      var slugKey = on.map(function (c) { return c.getAttribute('data-slug') || ''; })
                      .filter(Boolean).sort().join('|');
      var pack = null;
      for (var i = 0; i < PACKS.length; i++) {
        if (PACKS[i].key === slugKey) { pack = PACKS[i]; break; }
      }
      return { on: on, pack: pack, slugKey: slugKey };
    }

    function recompute() {
      var sel = getSelection();
      currentSelection = sel;
      var on = sel.on;
      var pack = sel.pack;
      updateHeroImage(sel.slugKey);
      var count = on.length;
      var total = cards.length;
      var isFull = count === total && total > 0;

      /* Compteur */
      if (elCount) elCount.textContent = count;

      /* Bouton restore */
      if (elRestore) {
        elRestore.style.display = (!isFull && count > 0) ? 'flex' : 'none';
        if (elRestoreP) elRestoreP.textContent = fmtEuro(FULL_PACK.price);
      }

      /* Prix */
      var finalP, oldP, discount, savings;
      if (pack) {
        finalP   = pack.price;
        oldP     = pack.compareAt;
        discount = pack.discount;
        savings  = oldP - finalP;
        currentUrl = pack.url;
      } else {
        finalP   = on.reduce(function (s, c) { return s + (parseFloat(c.getAttribute('data-price')) || 0); }, 0);
        oldP     = 0;
        discount = 0;
        savings  = 0;
        currentUrl = FULL_PACK.url;
      }

      if (elPrice) elPrice.textContent = count > 0 ? fmtEuro(finalP) : '—';
      if (elOld) {
        elOld.hidden = !(pack && oldP);
        if (pack && oldP) elOld.textContent = fmtEuro(oldP);
      }
      if (elBadge) {
        elBadge.hidden = !(pack && discount);
        if (pack && discount) elBadge.textContent = '−' + discount + ' %';
      }
      if (elNote) {
        if (pack && discount > 0) {
          elNote.classList.add('is-full');
          elNote.textContent = fill(T.noteFull, { savings: fmtEuro(savings), pack: pack.name });
        } else if (count === 0) {
          elNote.classList.remove('is-full');
          elNote.textContent = T.noteEmpty;
        } else if (count > 1) {
          elNote.classList.remove('is-full');
          elNote.textContent = T.notePartial;
        } else {
          elNote.classList.remove('is-full');
          elNote.textContent = '';
        }
      }
      if (elCta) {
        elCta.disabled = count === 0;
        if (count === 0) {
          elCta.textContent = T.ctaEmpty;
        } else if (isFull) {
          elCta.textContent = fill(T.ctaFull, { price: fmtEuro(finalP) });
        } else {
          elCta.textContent = fill(T.ctaPartial, { count: count, price: fmtEuro(finalP) });
        }
      }
    }

    /* Toggle cartes */
    cards.forEach(function (card) {
      card.addEventListener('click', function () {
        var isOn = card.classList.toggle('is-on');
        card.classList.toggle('is-off', !isOn);
        card.setAttribute('aria-pressed', isOn ? 'true' : 'false');
        card.setAttribute('aria-label', (isOn ? 'Retirer ' : 'Ajouter ') +
          (card.querySelector('.endro-aa-pcard-name') || {textContent:''}).textContent + (isOn ? ' de' : ' à') + ' la routine');
        recompute();
      });
    });

    /* Bouton restore → sélectionner tout */
    if (elRestore) {
      elRestore.addEventListener('click', function () {
        cards.forEach(function (c) {
          c.classList.add('is-on');
          c.classList.remove('is-off');
          c.setAttribute('aria-pressed', 'true');
        });
        recompute();
      });
    }

    /* CTA → ajout panier direct (/cart/add.js) */
    var ctaBusy = false;
    var ctaDefaultLabel = '';

    function buildCartItems() {
      var sel = currentSelection;
      if (sel.pack && sel.pack.variantId) {
        return [{ id: parseInt(sel.pack.variantId, 10), quantity: 1 }];
      }
      return sel.on
        .map(function (c) { return parseInt(c.getAttribute('data-variant-id'), 10); })
        .filter(function (id) { return !isNaN(id) && id > 0; })
        .map(function (id) { return { id: id, quantity: 1 }; });
    }

    if (elCta) {
      elCta.addEventListener('click', function () {
        if (elCta.disabled || ctaBusy) return;

        var sel = currentSelection;
        var items = buildCartItems();
        var incomplete = !sel.pack && items.length !== sel.on.length;
        if (!items.length || incomplete) {
          console.error('[endro-aa-hero-product] variant_id manquant sur au moins un produit sélectionné, fallback redirection.');
          window.location.href = currentUrl;
          return;
        }

        ctaBusy = true;
        ctaDefaultLabel = elCta.textContent;
        elCta.disabled = true;
        elCta.textContent = 'Ajout en cours…';

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: items })
        })
          .then(function (res) {
            if (!res.ok) return res.json().then(function (err) { throw err; });
            return res.json();
          })
          .then(function () {
            ctaBusy = false;
            elCta.disabled = false;
            elCta.textContent = ctaDefaultLabel;
            document.dispatchEvent(new CustomEvent('cart:refresh'));
            var drawer = document.getElementById('cart-drawer');
            if (drawer && typeof drawer.show === 'function') { drawer.show(); }
            else if (drawer) { drawer.setAttribute('open', ''); }
            else { window.location.href = '/cart'; }
          })
          .catch(function (err) {
            console.error('[endro-aa-hero-product] cart/add.js failed', err);
            ctaBusy = false;
            elCta.disabled = false;
            elCta.textContent = 'Réessayer — erreur ajout panier';
            setTimeout(function () { elCta.textContent = ctaDefaultLabel; }, 2500);
          });
      });
    }

    /* Réassurances mobile : slider auto (2800ms) */
    var rTrack = hero.querySelector('[data-reassure-track-pv2]');
    var rDots  = Array.prototype.slice.call(hero.querySelectorAll('[data-reassure-dot-pv2]'));
    if (rTrack && rDots.length > 1) {
      var rIdx = 0;
      function setR(i) {
        rIdx = i;
        rTrack.style.transform = 'translateX(-' + (i * 100) + '%)';
        rDots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
      }
      rDots.forEach(function (d, k) { d.addEventListener('click', function () { setR(k); }); });
      setInterval(function () { setR((rIdx + 1) % rDots.length); }, 2800);
    }

    /* Init initial */
    recompute();
  }

})();
